export type ThemeMode = "light" | "dark";
export type ResolvedTheme = ThemeMode;

export const THEME_STORAGE_KEY = "theme";
export const DARK_MEDIA_QUERY = "(prefers-color-scheme: dark)";

export function isThemeMode(value: string | null): value is ThemeMode {
	return value === "light" || value === "dark";
}

export function readThemeMode(): ThemeMode {
	if (typeof window === "undefined") {
		return "light";
	}

	const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
	if (isThemeMode(stored)) {
		return stored;
	}

	return window.matchMedia?.(DARK_MEDIA_QUERY).matches ? "dark" : "light";
}

export function writeThemeMode(mode: ThemeMode) {
	if (typeof window === "undefined") {
		return;
	}

	window.localStorage.setItem(THEME_STORAGE_KEY, mode);
}

export function applyTheme(mode: ThemeMode) {
	if (typeof document === "undefined") {
		return;
	}

	const root = document.documentElement;

	root.classList.toggle("dark", mode === "dark");
	root.dataset.theme = mode;
	root.dataset.themeMode = mode;
	root.style.colorScheme = mode;
}

export function getNextThemeMode(mode: ThemeMode): ThemeMode {
	return mode === "light" ? "dark" : "light";
}

export const THEME_INIT_SCRIPT = `(function(){try{var key='theme';var stored=window.localStorage.getItem(key);var mode=(stored==='light'||stored==='dark')?stored:(window.matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light');var root=document.documentElement;root.classList.toggle('dark',mode==='dark');root.dataset.theme=mode;root.dataset.themeMode=mode;root.style.colorScheme=mode;}catch(e){}})();`;
